module.exports = __webpack_public_path__ + "72a9ab615db9639796deea4b27d40792.png";


//////////////////
// WEBPACK FOOTER
// ./content/ucsc_logo.png
// module id = 1333
// module chunks = 0